module.exports = __webpack_public_path__ + "static/media/gsk.32aec41c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/labs/gsk.png
// module id = 127
// module chunks = 0